import api from "./api";

export const getCards = async (limit, offset, search) => {
  return await api.post("/card/list", { limit, offset, search });
};

export const deleteCard = async (id) => {
  return await api.delete(`/card/${id}`)
};